export const copyFields = [
  ['eyebrow', '活动标签', '充值特惠活动'],
  ['slogan', '活动标语', '让创作灵感加倍'],
  ['heading', '活动主标题', '零售价基础上5折优惠'],
  ['subtitle', '活动副标题', '充值 1 元可获得 200 积分'],
  ['terms', '底部活动说明', '活动期间，到账积分 = 实付金额 × 200，不叠加额外赠送。'],
  ['frontCaption', '翻转卡正面标题', '充值专享'],
  ['frontNote', '翻转卡正面说明', '同等金额 · 双倍积分'],
  ['backCaption', '翻转卡背面标题', '每充值 1 元'],
  ['backNote', '翻转卡背面说明', '积分即享 · 灵感加倍'],
  ['frontHint', '正面操作提示', '点击翻转 ↗'],
  ['backHint', '背面操作提示', '点击翻回 ↗'],
] as const
type Key = typeof copyFields[number][0]
export type Copy = Record<Key, string>
export const defaultCopy = Object.fromEntries(copyFields.map(([k,,v]) => [k,v])) as Copy

export const campaignFields = [
  ['start', '活动背景起始色', '#373027'], ['end', '活动背景结束色', '#30271d'],
  ['border', '活动卡片边框', '#e8c186'], ['title', '活动标题颜色', '#ffe4b2'],
  ['text', '活动说明文字', '#e6ddcf'], ['ticketStart', '翻转卡起始色', '#4b402d'],
  ['ticketEnd', '翻转卡结束色', '#30291e'], ['ticketBorder', '翻转卡边框', '#f8d699'],
  ['ticketText', '翻转卡文字与折扣', '#f5d397'],
] as const
type ColorKey = typeof campaignFields[number][0]
export type CampaignColors = Partial<Record<ColorKey, string>>

export type Colors = Partial<Record<'background' | 'backgroundEnd' | 'text' | 'border' | 'button' | 'buttonText', string>>
export type PackageColors = Record<string, Colors>
export const packageColorKeys = ['background', 'backgroundEnd', 'text', 'border', 'button', 'buttonText'] as const
export const packageColorLabels = ['卡片颜色（起始）', '卡片颜色（结束）', '文字颜色', '卡片边框', '按钮背景', '按钮文字']
const validColor = (value: unknown): value is string => typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value)

export interface Presentation { version: number; campaignCopy?: Partial<Copy>; campaignColors?: CampaignColors; packageColors?: PackageColors }
export function presentationCSS(scope: string, presentation: Presentation, plans: {code:string; recommended?:boolean}[]) {
 const config = presentation.campaignColors || {};
  const packageCSS = plans.map(p => {
    const c = presentation.packageColors?.[p.code] || {}
    const s = `#${scope} .recharge-options>article[data-preview-key="${encodeURIComponent(p.code)}"]`
    return [
      validColor(c.background) || validColor(c.backgroundEnd) ? `${s}{background:linear-gradient(${p.recommended ? 125 : 135}deg,${c.background || (p.recommended ? '#232b34' : '#393939')},${c.backgroundEnd || (p.recommended ? '#141617' : '#1c1c1c')})!important}` : '',
      validColor(c.border) ? `${s}{border-color:${c.border}!important}` : '',
      validColor(c.text) ? `${s} h2 span,${s} .recharge-points,${s} .recharge-price,${s} .recharge-points-note,${s} .recharge-points-note b,${s} .recharge-saving{color:${c.text}!important;background-clip:initial;-webkit-text-fill-color:initial}` : '',
      validColor(c.button) ? `${s} .recharge-buy{background:${c.button}!important;border-color:${c.button}!important}` : '',
      validColor(c.buttonText) ? `${s} .recharge-buy{color:${c.buttonText}!important}` : '',
    ].join('\n')
  }).join('\n')
  const base = `#${scope} .recharge-promotion`
  const color = (k: ColorKey) => config[k] || campaignFields.find(([key]) => key === k)![2]
  const campaignCSS = [
    config.start || config.end ? `${base}{background:linear-gradient(125deg,${color('start')},${color('end')})!important}` : '',
    config.border ? `${base}{border-color:${color('border')}!important}` : '',
    config.title ? `${base} .recharge-promotion-title,${base} .recharge-promotion-eyebrow{color:${color('title')}!important}` : '',
    config.text ? `${base} .recharge-promotion-subtitle,${base} .recharge-promotion-rate,${base} .recharge-promotion-rate b,${base} .recharge-promotion-terms,${base} .recharge-promotion-eyebrow>span{color:${color('text')}!important}` : '',
    config.ticketStart || config.ticketEnd ? `${base} .recharge-ticket-face{background:linear-gradient(140deg,${color('ticketStart')},${color('ticketEnd')})!important}` : '',
    config.ticketBorder ? `${base} .recharge-ticket-face{border-color:${color('ticketBorder')}!important}` : '',
    config.ticketText ? `${base} .recharge-ticket-face b{background:none!important;color:${color('ticketText')}!important}${base} .recharge-ticket-face strong,${base} .recharge-ticket-face small,${base} .recharge-ticket-caption,${base} .recharge-ticket-hint{color:${color('ticketText')}!important}` : '',
  ].join('\n')

return packageCSS + "\n" + campaignCSS;
}
